import * as React from "react";
const SvgPageBack = (props) => /* @__PURE__ */ React.createElement("svg", { width: 21, height: 14, viewBox: "0 0 21 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M20 7H2M2 7L8 1M2 7L8 13", stroke: "#78829A", strokeWidth: 1.5, strokeLinecap: "round" }));
export default SvgPageBack;
